import {GetterTree} from 'vuex'
import {WidgetState} from "@/apps/MyStudyChoiceOnboardingWidget/models/store-viewmodel"
import {Config, ISteps, IStep, Labels} from "../models/config-viewmodel"

export default <GetterTree<WidgetState, WidgetState>>{
    getConfig(state): Config {
        return state.config
    },
    getLabels(state): Labels {
        return state.config.labels
    },
    getMyStudyChoice(state): string {
        return state.myStudyChoice
    },
    getActiveStep(state): IStep {
        return state.steps[state.activeStepIndex]
    },
    getActiveSubStep(state): IStep | void {
        let subSteps: ISteps | undefined = state.steps[state.activeStepIndex].subSteps
        if(subSteps) return subSteps[state.activeSubStepIndex] 
    },
    getActiveStepIndex(state): number {
        return state.activeStepIndex
    },
    getActiveSubStepIndex(state): number {
        return state.activeSubStepIndex
    },
    getSteps(state): ISteps {
        return state.steps
    },
    getIsLastStep(state): boolean {
        let Steps: ISteps = state.steps
        let subSteps: ISteps | undefined = state.steps[state.activeStepIndex].subSteps
        return ((Steps.length - 1) <= state.activeStepIndex) && (((subSteps?.length ?? 1) - 1) <= state.activeSubStepIndex)
    },
    getReverse(state): boolean {
        return state.reverse
    },
    getCanContinue(state): boolean {
        return state.canContinue
    },
    getOnboardingIsActive(state): boolean {
        return state.onboardingIsActive
    },
    getOnboardingIsCompleted(state): boolean {
        return state.onboardingIsCompleted
    }
}
